import { DataAccess } from "../../dataaccess/data.access";
import type { UpdatedContactRoles } from "../organization.service";
import { partitionMemberRemovals } from "./organization.profile.members.util";

const SERVICE = "OrganizationProfileApi";

export type OrganizationProfileEligibilityReason = "notSeOrg" | "accountRight" | "ols";

export type OrganizationProfileRatingsResult = {
    updatedOrgIds: number[];
    skipped: { orgId: number; reason: OrganizationProfileEligibilityReason }[];
};

export class OrganizationProfileApi {
    public static saveProfile(
        acctId: number,
        patch: { updateMission?: boolean; mission?: string | null; updateLogo?: boolean; logo?: string | null },
    ) {
        const url = `/organization/${acctId}/profile.json`;
        return DataAccess.put<void>(DataAccess.injectCaller(url, `${SERVICE}.saveProfile`), patch);
    }

    public static saveRating(orgIds: number[], ratingId: number) {
        const url = `/organization/ratings.json`;
        return DataAccess.put<OrganizationProfileRatingsResult>(DataAccess.injectCaller(url, `${SERVICE}.saveRating`), {
            orgIds,
            ratingId,
        });
    }

    public static saveMembers(acctId: number, updates: UpdatedContactRoles) {
        const combined = updates.added.concat(...updates.updated);
        const added = combined
            .filter((item) => !!item)
            .map((item) => ({
                contId: item.itemId,
                roleId: item.role?.itemId,
            }));
        const { removed, removedContacts } = partitionMemberRemovals(updates.removed.filter((item) => !!item));
        const url = `/organization/${acctId}/members.json`;
        const body: {
            added: { contId: number; roleId?: number }[];
            removed: { contId: number; roleId?: number }[];
            removedContacts?: number[]; //completely removing a contact from the org (all roles)
            primeContactId?: number;
        } = {
            added,
            removed,
            primeContactId: updates.primaryId,
        };
        if (removedContacts.length) {
            body.removedContacts = removedContacts;
        }
        return DataAccess.put<void>(DataAccess.injectCaller(url, `${SERVICE}.saveMembers`), body);
    }
}
